import ModalsLib from '../../../../../lib/modals';
import Diamond from '../../diamond';

export default () => {
    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/facebook.png`} alt="Facebook Icon" />
                </div>
                <div className="title">Facebook Stream</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Play with Lucksy on a live stream and get diamonds
                </div>
                <div className="button-block">
                    <div className="button" onClick={e => window.open('https://t.me/lucksy_affiliate_support_bot', '_blank')}> 
                        Support
                    </div>
                    <div className="diamonds">
                        <Diamond />
                        10
                    </div>
                </div>
            </div>
        </div>
    )
}